import React from 'react';
import PropTypes from 'prop-types';
import NotesIcon from '@mui/icons-material/Notes';
import { Card } from '@totalsoft/rocket-ui';
import ServiceRequestComponent from './ServiceRequestComponent';
import LoadingWrapper from 'components/common/LoadingWrapper';
import { LogRequestsContainer } from './ServiceLogStyles';
import { LoadingCard } from 'components/common/SurfaceStyles';

const ServiceLogsComponent = ({ requests, loadingStarted, count, onDownloadFile }) => {
  return loadingStarted ? (
    <Card id='CommentsComponent_IconCard' icon={NotesIcon}>
      <LogRequestsContainer>
        {requests.map((request, index) => (
          <ServiceRequestComponent request={request} onDownloadFile={onDownloadFile} key={index} id={index} />
        ))}
        {[...Array(count).keys()].map(key => (
          <LoadingCard key={key}>
            <LoadingWrapper loading></LoadingWrapper>
          </LoadingCard>
        ))}
      </LogRequestsContainer>
    </Card>
  ) : (
    <></>
  );
};

ServiceLogsComponent.propTypes = {
  requests: PropTypes.array,
  loadingStarted: PropTypes.bool,
  count: PropTypes.number,
  onDownloadFile: PropTypes.func
};

export default ServiceLogsComponent;
